import { getToken, currentUser } from './session';

export class ApiError extends Error {
  constructor(status, body) {
    super((body && body.message) || `Request failed with status ${status}`);
    this.status = status;
    this.body = body;
  }
}

/**
 * Calls the Patternade API, which is on the same origin under /api.
 * The login token goes in the `token` header whenever the visitor is signed in. Routes that need a
 * login fail straight away with a 401 when nobody is signed in, without calling the API.
 */
export async function request(path, { method = 'GET', body, auth = false } = {}) {
  const token = currentUser() ? getToken() : null;
  if (auth && !token) throw new ApiError(401, { message: 'Please sign in' });

  const headers = { Accept: 'application/json' };
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (token) headers.token = token;

  const response = await fetch(`/api${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) throw new ApiError(response.status, data);
  return data;
}

const id = (value) => encodeURIComponent(value);

export const gallery = {
  categories: () => request('/gallery/categories'),
  patterns: (category, page) => request(`/gallery/list/${id(category)}/${Number(page) || 0}`),
  pattern: (patternId) => request(`/gallery/pattern/${id(patternId)}`),
  recordView: (patternId) => request(`/gallery/pattern/${id(patternId)}/view`, { method: 'POST', body: {} }),
  toggleLike: (patternId) => request(`/gallery/pattern/${id(patternId)}/like`, { method: 'PUT', body: {}, auth: true }),
  download: (patternId, format) => request(`/gallery/pattern/${id(patternId)}/download`, { method: 'POST', body: { format }, auth: true }),
};

export const account = {
  signIn: (identifier, password) => request('/auth/signin', { method: 'POST', body: { user_name: identifier, password } }),
};
